exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-3d216116]{top:7px;left:50%;transform:translateX(-50%)}", ""]);

// exports
